import {
    AI_LEVEL, FREE,
    PRICES,
    RESTORE, RESTORE_PRICES, TON, TON_WALLET_ADDRESS
} from "../consts/consts";
const CryptoJS = require("crypto-js");
import TonWeb from "tonweb";

export function tonTx() {

    function encrypt(plainText, keyString, ivString) {
        const key = CryptoJS.enc.Utf8.parse(keyString);
        const iv = CryptoJS.enc.Utf8.parse(ivString);
        const encrypted = CryptoJS.AES.encrypt(plainText, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
        return encrypted.toString();
    }

    async function getUpgradeAiLevelTonTx(tgUserId, level) {

        const timestamp = Date.now();
        const text = tgUserId.toString() + ":" + "ai_level_" + level.toString()+":"+timestamp;
        const secretKey = "investoriumcokey";
        const secretIv = "investoriumcomiv";
        const encryptedText = encrypt(text, secretKey, secretIv);
        let a = new TonWeb.boc.Cell();
        a.bits.writeUint(0, 32);
        a.bits.writeString(encryptedText);
        let payload = TonWeb.utils.bytesToBase64(await a.toBoc());
        let price = (PRICES["AI_LEVEL_"+level.toString()][TON]*1000000000).toString();
        const transaction = {
            validUntil: Date.now() + 5 * 60 * 1000, // 5 minutes
            messages: [
                {
                    address: TON_WALLET_ADDRESS,
                    amount: price, // Toncoin in nanotons
                    payload: payload
                },
            ],
        };
        return transaction;
    }

    async function getRestoreEnergyTonTx(tgUserId, level, subscription) {

        const timestamp = Date.now();
        const text = tgUserId.toString() + ":" + RESTORE +":"+timestamp;
        const secretKey = "investoriumcokey";
        const secretIv = "investoriumcomiv";
        const encryptedText = encrypt(text, secretKey, secretIv);

        let a = new TonWeb.boc.Cell();
        a.bits.writeUint(0, 32);
        a.bits.writeString(encryptedText);
        let payload = TonWeb.utils.bytesToBase64(await a.toBoc());
        let price = (10000000).toString();
        if (subscription.toUpperCase() === FREE.toUpperCase()) {
            price = (RESTORE_PRICES["AI_LEVEL_"+level.toString()][TON]*1000000000).toString();
        } else {
            price = (RESTORE_PRICES[subscription.toString().toUpperCase()][TON]*1000000000).toString();
        }
        const transaction = {
            validUntil: Date.now() + 5 * 60 * 1000, // 5 minutes
            messages: [
                {
                    address: TON_WALLET_ADDRESS,
                    amount: price, // Toncoin in nanotons
                    payload: payload
                },
            ],
        };

        return transaction;
    }

    async function getUpgradeSubscriptionTonTx(tgUserId, subscription) {

        const timestamp = Date.now();

        const text = tgUserId.toString() + ":" + "subscription_" + subscription.toString()+":"+timestamp;
        const secretKey = "investoriumcokey";
        const secretIv = "investoriumcomiv";
        const encryptedText = encrypt(text, secretKey, secretIv);

        let a = new TonWeb.boc.Cell();
        a.bits.writeUint(0, 32);
        a.bits.writeString(encryptedText);
        let payload = TonWeb.utils.bytesToBase64(await a.toBoc());
        let price = (PRICES[subscription.toString().toUpperCase()][TON]*1000000000).toString();

        const transaction = {
            validUntil: Date.now() + 5 * 60 * 1000, // 5 minutes
            messages: [
                {
                    address: TON_WALLET_ADDRESS,
                    amount: price, // Toncoin in nanotons
                    payload: payload
                },
            ],
        };
        return transaction;
    }


    return {
        getUpgradeAiLevelTonTx: getUpgradeAiLevelTonTx,
        getRestoreEnergyTonTx: getRestoreEnergyTonTx,
        getUpgradeSubscriptionTonTx: getUpgradeSubscriptionTonTx
    }
}
